<div class="screen-element splashscreen">
  <!--<app-statusbar class="screen-element"></app-statusbar>-->
  <div class="dashboard-center">
    @if (dashIcon) {
      <div class="icon {{dashIcon}}"></div>
    }
  </div>
  <text-widget [color]="'white'" class="text text-1" [text]="getText(0)"></text-widget>
  <text-widget [color]="'white'" class="text text-2" [text]="getText(1)"></text-widget>
  <text-widget [color]="'white'" class="text text-3" [text]="getText(2)"></text-widget>
</div>